<div class="tw-flex tw-flex-col tw-gap-3">
  @if (isTwoCard()) {
    <div class="tw-flex tw-gap-4">
      <div class="tw-flex-1 tw-flex tw-flex-col tw-gap-2">
        <div role="button" tabindex="0"
          class="tw-relative tw-w-full tw-aspect-quiz-photo-card tw-rounded-2xl tw-overflow-hidden tw-bg-white tw-border-solid tw-border-white tw-border-4 tw-shadow-z4 tw-cursor-pointer"
          (click)="onOpenAlternate()"
          (keydown.enter)="onOpenAlternateKeydown($event)"
          (keydown.space)="onOpenAlternateKeydown($event)">
          <img class="tw-w-full tw-h-full tw-object-cover" [src]="alternatePhotoUrl()" alt="">
          <cs-icon [iconName]="checkIcon" class="tw-text-teal-600 tw-w-4 tw-h-4 tw-absolute tw-top-1 tw-right-1"></cs-icon>
        </div>
        <span class="tw-text-300 tw-text-center tw-text-gray-800">{{ alternateLabel() }}</span>
      </div>
      <div class="tw-flex-1 tw-flex tw-flex-col tw-gap-2">
        <div role="button" tabindex="0"
          [class]="currentPhotoUrl()
            ? 'tw-relative tw-w-full tw-aspect-quiz-photo-card tw-rounded-2xl tw-overflow-hidden tw-bg-white tw-border-solid tw-border-white tw-border-4 tw-shadow-z4 tw-cursor-pointer'
            : 'tw-relative tw-w-full tw-aspect-quiz-photo-card tw-flex tw-items-center tw-justify-center tw-cursor-pointer'"
          (click)="onCapture()"
          (keydown.enter)="onCaptureKeydown($event)"
          (keydown.space)="onCaptureKeydown($event)">
          @if (currentPhotoUrl()) {
            <img data-testid="quiz-current-photo" class="tw-w-full tw-h-full tw-object-cover" [src]="currentPhotoUrl()" alt="">
            <cs-icon [iconName]="checkIcon" class="tw-text-teal-600 tw-w-4 tw-h-4 tw-absolute tw-top-1 tw-right-1"></cs-icon>
          } @else {
            <img class="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-pointer-events-none" [src]="dashedBorderCardImage" alt="">
            <ng-container [ngTemplateOutlet]="captureFrame" />
          }
        </div>
        <span class="tw-text-200 tw-text-center tw-text-gray-500">{{ currentLabel() }}</span>
      </div>
    </div>
  } @else {
    <div id="quiz-photo-upload" role="button" tabindex="0"
      [class]="currentPhotoUrl()
        ? 'tw-relative tw-w-full tw-aspect-quiz-photo tw-rounded-2xl tw-overflow-hidden tw-bg-white tw-border-solid tw-border-white tw-border-4 tw-shadow-z4 tw-cursor-pointer'
        : 'tw-relative tw-w-full tw-aspect-quiz-photo tw-flex tw-items-center tw-justify-center tw-cursor-pointer'"
      (click)="onCapture()"
      (keydown.enter)="onCaptureKeydown($event)"
      (keydown.space)="onCaptureKeydown($event)">
      @if (currentPhotoUrl()) {
        <img data-testid="quiz-current-photo" class="tw-w-full tw-h-full tw-object-cover" [src]="currentPhotoUrl()" alt="">
        <cs-icon [iconName]="checkIcon" class="tw-text-teal-600 tw-w-4 tw-h-4 tw-absolute tw-top-1 tw-right-1"></cs-icon>
      } @else {
        <img class="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-pointer-events-none" [src]="dashedBorderImage" alt="">
        <ng-container [ngTemplateOutlet]="captureFrame" />
      }
    </div>
  }
  <p class="tw-flex tw-items-center tw-justify-center tw-gap-1 tw-text-200 tw-text-gray-500">
    <em class="cs-icon-lock tw-text-300"></em>
    <span class="tw-lowercase" i18n="@@securePhotoPrivacyProtected">Secure Photo | Privacy Protected</span>
  </p>
</div>

<ng-template #captureFrame>
  <span class="tw-relative tw-w-19 tw-h-27 tw-flex tw-items-center tw-justify-center">
    <img class="tw-absolute tw-inset-0 tw-w-full tw-h-full" [src]="scanFrameImage" alt="">
    @if (imageUrl()) {
      <img data-testid="quiz-photo-illustration" class="tw-w-15 tw-h-19 tw-object-contain" [src]="imageUrl()" alt="" />
    } @else {
      <em class="cs-icon-person tw-text-1200 tw-text-gray-400"></em>
    }
  </span>
</ng-template>
